import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import Iconify from 'src/components/iconify/Iconify';
import { Stack, padding } from '@mui/system';
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import { createOdooURL } from '../../routes/odooURL';

export default function ApplicationsPage() {
  const { translate } = useLocales();

  type IconifyIcon = string;

  interface CardData {
    icon: IconifyIcon;
    title: string;
    description: string;
    url?: string;
  }

  const cardsServices: CardData[] = [
    {
      icon: 'mdi:briefcase-outline', // Icône représentant un projet ou une affaire
      title: `${translate('upComingAppsPage.services.project.title')}`,
      description: `${translate(
        'upComingAppsPage.services.project.description'
      )}`,
      url: createOdooURL('project'),
    },
    {
      icon: 'mdi:timer', // Icône représentant une minuterie pour la feuille de temps
      title: `${translate('upComingAppsPage.services.timeSheet.title')}`,
      description: `${translate(
        'upComingAppsPage.services.timeSheet.description'
      )}`,
      url: createOdooURL('timesheet'),
    },
    {
      icon: 'mdi:hammer-screwdriver', // Icône représentant des outils pour les services sur site
      title: `${translate('upComingAppsPage.services.onSite.title')}`,
      description: `${translate(
        'upComingAppsPage.services.onSite.description'
      )}`,
      url: createOdooURL('on_site'),
    },
    {
      icon: 'mdi:account-multiple-check-outline', // Icône représentant une assistance ou un support client
      title: `${translate('upComingAppsPage.services.support.title')}`,
      description: `${translate(
        'upComingAppsPage.services.support.description'
      )}`,
      url: createOdooURL('support'),
    },
    {
      icon: 'mdi:calendar-clock', // Icône représentant une planification ou un emploi du temps
      title: `${translate('upComingAppsPage.services.schedule.title')}`,
      description: `${translate(
        'upComingAppsPage.services.schedule.description'
      )}`,
      url: createOdooURL('schedule'),
    },
    {
      icon: 'mdi:clock-time-four-outline', // Icône représentant un horaire ou un rendez-vous
      title: `${translate('upComingAppsPage.services.rendezvous.title')}`,
      description: `${translate(
        'upComingAppsPage.services.rendezvous.description'
      )}`,
      url: createOdooURL('rendezvous'),
    },
  ];

  return (
    <>
      <Helmet>
        <title> {`${translate('upComingAppsPage.title')}`} </title>
      </Helmet>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Typography
            variant="h3"
            paragraph
            align="center"
            sx={{ marginTop: '70px', marginBottom: '100px' }}
          >
            {`${translate('upComingAppsPage.appList')}`}
          </Typography>

          <Grid container spacing={12} sx={{ maxWidth: '1000px' }}>

            <Grid item>
              <Typography variant="h4" paragraph>
                {`${translate('upComingAppsPage.services.title')}`}
              </Typography>

              <Typography sx={{ marginBottom: '20px' }}>
                {`${translate('upComingAppsPage.services.description')}`}
              </Typography>

              <Grid container spacing={2}>
                {cardsServices.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardActionArea
                        component="a"
                        href={card.url}
                        target="_bank"
                      >
                        <CardContent
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <div>
                            <Icon
                              icon={card.icon}
                              width={32}
                              style={{ marginRight: 16 }}
                            />
                          </div>
                          <div>
                            <Typography variant="h6">{card.title}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {card.description}
                            </Typography>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Typography variant="h4" sx={{ marginTop: '80px' }} align="center">
            {`${translate('upComingAppsPage.footer.line1')}`} <br />
            {`${translate('upComingAppsPage.footer.line2')}`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
